import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Send = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M44.969 22c0-.688-.392-1.315-1.006-1.606L3.443 1.166a1.716 1.716 0 0 0-1.965.354 1.797 1.797 0 0 0-.346 2.003l7.678 16.73h10.202c.824 0 1.491.68 1.491 1.519 0 .84-.667 1.519-1.49 1.519H9.02L1.133 40.477a1.797 1.797 0 0 0 .345 2.003 1.718 1.718 0 0 0 1.966.354l40.519-19.227A1.775 1.775 0 0 0 44.969 22Z"
  }));
});
Send.displayName = 'Send';
Send.defaultProps = {
  'aria-label': 'Send'
};
export default Send;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Send.js
// module id = 3280
// module chunks = 11